var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTenantAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_58_17",
    "data-name": "Component 58 \\u2013 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2674",
    "data-name": "Rectangle 2674",
    width: 20,
    height: 20,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13057",
    "data-name": "Group 13057"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13057-2",
    "data-name": "Group 13057",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12992",
    "data-name": "Path 12992",
    d: "M19.215,9.377h-.789a.263.263,0,0,0-.2.087q-1.676,1.679-3.354,3.356a.657.657,0,0,0-.063.084,3.411,3.411,0,0,0-1.062-.288c-.125-.011-.25-.017-.375-.017a3.253,3.253,0,0,0-2.413,1.028,3.384,3.384,0,0,0,1.423,5.593,6.48,6.48,0,0,0,.676.139c.028.006.219.012.25.017h.059c.187-.032.645-.055.83-.1a3.386,3.386,0,0,0,2.489-4.091,3.271,3.271,0,0,0-.176-.528.1.1,0,0,1,.028-.134q.5-.5,1-1a.228.228,0,0,0,.057-.134c.007-.155,0-.311,0-.484h.25c.053,0,.1,0,.156,0h.03a.314.314,0,0,0,.242-.112c.154-.167.318-.325.481-.483a.217.217,0,0,0,.077-.178c0-.171,0-.343,0-.525h.536a.21.21,0,0,0,.161-.071c.154-.158.313-.312.472-.463v-1.7Zm-6.495,8.17h0a.888.888,0,1,1,.865-.865.888.888,0,0,1-.865.865",
    fill: "#600097"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12993",
    "data-name": "Path 12993",
    d: "M9.2,18.314H1.649A6.7,6.7,0,0,1,8.255,11.78a6.469,6.469,0,0,1,1.959.3l.229.1a4.773,4.773,0,0,1,1.984-.937l-.237-.131a7.923,7.923,0,0,0-.718-.347A5.842,5.842,0,0,0,13.78,7.5a5.988,5.988,0,0,0-.51-4.477A5.675,5.675,0,0,0,5.455.747,5.976,5.976,0,0,0,3.239,8.759a5.82,5.82,0,0,0,1.8,2.01A8.482,8.482,0,0,0,0,18.558V20H10.74A4.812,4.812,0,0,1,9.2,18.314M4.157,5.893a4.155,4.155,0,0,1,4.1-4.2,4.156,4.156,0,0,1,4.1,4.2,4.156,4.156,0,0,1-4.1,4.2,4.163,4.163,0,0,1-4.1-4.2",
    fill: "#600097"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTenantAdd);
export default __webpack_public_path__ + "static/media/tenantAdd.dbada59ef31deb70f82f4ef4977b9b54.svg";
export { ForwardRef as ReactComponent };